import { Component } from '@angular/core';

@Component({
  selector: 'my-bill-overview-redesign-skeleton',
  templateUrl: './my-bill-overview-redesign-skeleton.component.html',
  standalone: false,
})
export class MyBillOverviewRedesignSkeletonComponent {}
